import React from 'react'

import { GotoDetailMenuItem } from './GotoDetailMenuItem'
import { ContextMenuProvider } from './Context'

import { ButtonGroup } from 'react-bootstrap'

export const RowContextMenu = ({ invoice }) => {
  return (
    <ContextMenuProvider invoice={invoice}>
      <ButtonGroup>
        {/*<PayGroupButtonMenu />*/}
        <GotoDetailMenuItem />
        {/*<PrintInvoiceButton bsStyle="info" code={invoice?.code} _id={invoice?._id} />*/}
        {/*<DeleteInvoice initialValues={invoice} />*/}
      </ButtonGroup>
    </ContextMenuProvider>
  )
}
